import React from 'react';
import styles from './index.less';
import SEARCH_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_search.svg';
import Input from '@tencent/dui/esm/components/Input';
import i18n from 'i18next';
import classnames from 'classnames';
import { getPptTemplate } from '@com/tool-bar/menu/utils';

interface ITemplateTopicMenuProps {
    selectedTopicId: string;
    onTopicSelect(topicId: string, topicList?: Array<ITopic>);
    onTopicInit(topicList?: Array<ITopic>);
    onSearch(searchKey: string);
}

interface ITemplateTopicMenuState {
    topicList: Array<ITopic>;
    searchValue: string;
}

export interface ITopic {
    topicId: string,
    style: {
        desc: string,
        id?: string,
    },
}

/**
 * 美化面板 - topic菜单导航
 */
export default class TemplateTopicMenu extends React.Component<ITemplateTopicMenuProps, ITemplateTopicMenuState> {
    constructor(props: ITemplateTopicMenuProps) {
        super(props);
        this.state = {
            topicList: [],
            searchValue: '',
        };
        this.getTopicList();
    }

    public render() {
        const { selectedTopicId } = this.props;
        return (
            <div className={styles['template-topic-menu-container']}>
                <div className={styles['template-topic-item-container-scroll']}>
                    <div className={styles['template-topic-item-container']}>
                        {
                            this.state.topicList.map((item, index) => <div
                                key={item.topicId}
                                onClick={() => {
                                    this.props.onTopicSelect(item.topicId);
                                }}
                                className={classnames({
                                    [styles['template-topic-menu-item']]: true,
                                    [styles['menu-item-selected']]: item.topicId === selectedTopicId,
                                })}
                            >
                                {
                                    item.style?.desc
                                }
                            </div>)
                        }
                    </div>
                </div>
                <div className={styles['template-topic-item-mask']}/>
                <div className={styles['template-topic-search']}>
                    <Input
                        value={this.state.searchValue}
                        onChange={(searchValue) => {
                            this.setState({
                                searchValue,
                            });
                        }}
                        onKeyUp={(event) => {
                            if (event.key === 'Enter') {
                                this.handleSearch();
                            }
                        }}
                        className={classnames({
                            [styles['template-topic-search-input']]: true,
                            'template-topic-search-for-global': true,
                        })}
                        leftIcon={SEARCH_ICON}
                        placeholder={i18n.t('搜索')}
                    />
                </div>
            </div>
        );
    }

    private handleSearch = () => {
        const searchKey = this.state.searchValue.replaceAll(' ', '');
        this.props.onSearch(searchKey);
    };

    private getTopicList = async () => {
        if (this.state.topicList.length) return;

        const res = await getPptTemplate();
        const topicCgiList = res?.[0];
        if (topicCgiList?.length) {
            const topicList: ITopic[] = topicCgiList.filter?.((topic: ITopic) => topic.topicId && topic.style?.desc);

            topicList.unshift({
                topicId: '',
                style: {
                    desc: i18n.t('全部'),
                },
            });

            this.setState({
                topicList,
            });

            this.props.onTopicInit(topicList);
        }
    };
}
